// オブジェクトが空かどうかの判定
export const isObjEmpty = (obj) => {
  return Object.keys(obj).length === 0
}
 